import { useSession } from 'next-auth/react';
import { useEffect } from 'react';

import { useEventContext } from 'context/EventContext';
import { consumeMatchingOneTapAttempt } from 'shared-utils/oneTapAnalytics';

import { buildGetAppMarketingEvent } from './constants';

const reportedInDocument = new Set();

const OneTapAnalytics = () => {
  const { data: session, status } = useSession();
  const { sendEvent } = useEventContext();
  const user = session?.user;
  const partnerAuth = user?.partnerAuth;

  useEffect(() => {
    if (
      status !== 'authenticated' ||
      user?.provider !== 'g2' ||
      user?.redirectAuth
    ) {
      return;
    }

    const attemptId = consumeMatchingOneTapAttempt(partnerAuth);
    if (!attemptId || reportedInDocument.has(attemptId)) {
      return;
    }

    reportedInDocument.add(attemptId);
    const result = partnerAuth
      ? partnerAuth.isSignUp
        ? 'sign-up'
        : 'log-in'
      : undefined;
    const userId = user.externalId;
    try {
      Promise.resolve(
        sendEvent({
          ...buildGetAppMarketingEvent('form-submitted', attemptId, result),
          ...(userId ? { userId } : {}),
        })
      ).catch(() => undefined);
    } catch {
      // Analytics is best effort and must never affect the authenticated session.
    }
  }, [partnerAuth, sendEvent, status, user]);

  return null;
};

export default OneTapAnalytics;
